import {getRestApi} from './ApiAxios'

export const SolicitarDescargaMasivaCertificados = async (payload) => {
  const apiReq = await getRestApi()
  return await apiReq.post(
    'gato-api-function/SolicitarDescargaMasivaCertificados',
    payload
  )
}
